import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import client from "@/lib/api";
import LandingView from "@/components/LandingView";

export default function PublicLanding() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    client.get(`/public/landing/${slug}`).then(({ data }) => { setData(data); setStatus("ok"); }).catch(() => setStatus("error"));
  }, [slug]);

  if (status === "loading") return <div className="min-h-screen flex items-center justify-center"><div className="h-10 w-10 rounded-full border-2 border-indigo-500 border-t-transparent animate-spin" /></div>;
  if (status === "error") return <div className="min-h-screen flex flex-col items-center justify-center text-center px-6"><h1 className="font-display text-2xl font-bold">Page introuvable</h1><p className="text-slate-500 mt-2">Cette page événementielle n'existe pas ou n'est pas publiée.</p></div>;

  const ctx = { event: data.event, days: data.days, activities: data.activities, registration: data.registration, company: data.company, interactive: true, slug };
  return <LandingView blocks={data.page.blocks} ctx={ctx} />;
}
